import { defineStore } from "pinia";
const userStore = defineStore("digiCounsel:user", {
    state: () => {
        return {
            accessToken: "" as string | null,
            refreshToken: "" as string | null,
            userInfo: {} as any | null,
            roles: [] as any | null,
        };
    },
    actions: {
        setInfo(userInfo: object | null) {
            this.userInfo = userInfo;
        },
        setRole(roles: any | null) {
            this.roles = roles;
        },
        setAccessToken(accessToken: string | null) {
            this.accessToken = accessToken;
        },
        setRefreshToken(refreshToken: string | null) {
            this.refreshToken = refreshToken;
        },
        isLogin() {
            return this.accessToken && this.userInfo.idx;
        },
    },
});

export default userStore;
